// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selected-services__item[data-v-3426f427]{border-radius:8px;height:44px;margin-right:12px;overflow:hidden;transition:.2s ease-in-out;width:44px}@media screen and (min-width:960px){.selected-services__item[data-v-3426f427]{margin-right:8px}}.selected-services__item.is-empty[data-v-3426f427]{border:1px dashed var(--v-tertiary-base)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
